export const practicalExamShareTranslation = {
  invalidOrExpired: 'This share link is invalid or has expired.',
  noAttachments: 'No attachments',
  pdfPreviewError: 'Failed to load PDF preview',
  pdfPreviewLoading: 'Loading preview…',
  pdfPreviewPager: 'Page {{page}} / {{total}}',
  questions: 'Questions ({{count}})',
  reports: 'Reports ({{count}})',
  title: 'Practical exam attempt {{number}}',
};

export type PracticalExamShareTranslation = typeof practicalExamShareTranslation;
